import { Users } from 'lucide-react';
import * as React from 'react';
import { Translate } from 'react-localize-redux';
import EmailV2TemplateCreator from '../../containers_v2/forms/EmailV2TemplateCreator';
import FormTemplateCreator from '../../containers_v2/forms/FormTemplateCreator';
import FormViewTemplateCreator from '../../containers_v2/forms/FormViewTemplateCreator';
import FormInstanceView from '../../containers_v2/forms/instance-list/FormInstanceView';
import { PrimaryColor } from '../../styles/global/css/Utils';
import { Route } from '../Routes';

const FormsRoutes = (): Route[] => [
	{
		component: () => <></>,
		path: '/forms',
		name: <Translate id="sidebar.sales_operations" />,
		key: 'sidebar.sales_operation',
		sectionKey: 'forms',
		logoImg: <Users size='16' />,
		hoverImg: <Users color={PrimaryColor} size='16' />,
		activeImg: <Users color={PrimaryColor} size='16' />,
		title: 'EnForm',
		subTitle: 'EnForm',
		restricted: false,
		exact: true,
		menu: true,
		permission: [
			'ViewOpportunity',
			'ViewForm'
		],
		subroutes: [
			{
				path: '/opportunities',
				name: <Translate id="opportunities" />,
				permission: ['ViewOpportunity']
			}
		]
	},
	{
		component: FormTemplateCreator,
		path: '/form-template'
	},
	{
		component: FormViewTemplateCreator,
		path: '/form-view-template'
	},
	{
		component: EmailV2TemplateCreator,
		path: '/email-v2-template'
	},
	{
		component: FormInstanceView,
		path: '/form-instance-list'
	}
];

export default FormsRoutes;
